export default "__VITE_ASSET__BUgwNFTx__"